import './Team.css';
import React from 'react';
import {OurWork, OurTeam, FieldsShort} from '../../sections/index';
import {SectionHeader, SectionWrap, PageHead } from '../../Components/index';
import {ButtonSecoundry} from '../../Components/index';
import mohamedKh from '../../assest/images/team0.jpg';
import { TfiEmail } from "react-icons/tfi";
import { useTranslation } from 'react-i18next';





import AOS from 'aos'
import 'aos/dist/aos.css'
AOS.init();

function Team() {
  const { t, i18n } = useTranslation();

  return (
    <>
    <div className='teamContaner'>
        <PageHead title={t('ourTeam')} 
                  summary= {t('teamDiscSection')}
                  disc= {t('teamDiscSction2')}
                  btn= {t('contactUsTitle')}
                  hrefBtn='/askConsults'/>
        <div className='teamItemHolder'>
            <div className='containerNew'>
                <SectionWrap>
                <SectionHeader title={t('teamTitle')} disc={t('teamTitleDisc')}/>
                <div className='teamItemHead' data-aos="fade-up">
                    <img src={mohamedKh} alt='mohamad khalil albarede'/>
                    <div className='info'>
                        <h2>{t('mohamedKhalil')}</h2>
                        <span>{t('mohamedDisc')}</span>
                        <p>
                            {t('mohamedInfo')}
                            <br/>{t('mohamedInfo2')} 
                        </p>
                        <div className='social'>
                            <ButtonSecoundry href='https://mohamad.albarede.com/'>{t('cv')}</ButtonSecoundry>
                            <a href='#'>mohamad@albarede.com<TfiEmail /></a>
                        </div>
                    </div>
                </div>
            </SectionWrap>
            </div>
            <OurTeam />
            <OurWork />
            <FieldsShort />
        </div>
    </div>
    </>
  )
}

export default Team;